import React from "react";
import { useNavigate } from "react-router-dom";

export const LogoLink: React.FC<unknown> = () => {
  const navigate = useNavigate();
  return (
    <div
      onClick={() => navigate("/home")}
      className={
        "cursor-pointer px-2 font-notoSans text-[21px] font-bold normal-case text-[#7c66f0] md:px-4"
      }
      aria-label={"Home"}>
      ProCharted
    </div>
  );
};
